// @flow
import React, { useContext } from 'react';

import {
  FieldArrayGridConfigItemContext,
  FieldArrayGridSelectField,
} from '../../formik-utils/FieldArrayGrid';
import { CREDITS_AND_BURSTS_YEAR_NUMBER_BACKEND_NAME } from '../../constants';
import { CREDITS_AND_BURSTS_CONFIG_ARRAY_CONFIG_MAP } from '../../configuration/credits-and-bursts';

const getYearDropdownOptions = ({ calendarYears, cnbcInputs, initiallySelectedYear }) => {
  /*
Calendar Years will be an array of objects and each object will have year_number, calendar_year

In that list, we should first get the list of all Years which are still not taken
And post that, we need to add the initially selected year for that particular row

Example:
Assume 25, 26, 27 are the universe of years
Assume 25 and 26 are already taken
Now, in 25th row, we need to show 25 and 27
In 26th row, we need to show 26 and 27

In order to simplify the code, we will iterate over the array and remove elems which are taken and also keep the initiallySelectedYear
   */

  const calendarYearsToUse = calendarYears.filter((calendarYearObj) => {
    const currentCalendarYearNumber = calendarYearObj.year_number;

    // If it is initiallySelectedYear, then, keep it
    if (currentCalendarYearNumber === initiallySelectedYear) {
      return true;
    }

    // Otherwise, if it is NOT taken, then, keep it
    const isCurrentCalendarYearAlreadyTaken = cnbcInputs.find(
      (cnbcInputRow) => currentCalendarYearNumber === cnbcInputRow.year_number
    );

    return !isCurrentCalendarYearAlreadyTaken;
  });

  return calendarYearsToUse.map((x) => ({
    name: x.year_number,
    display_name: x.calendar_year,
  }));
};

export const YearContainer = ({ calendarYears, cnbcInputs }) => {
  const { rowValues } = useContext(FieldArrayGridConfigItemContext);
  const initiallySelectedYear = cnbcInputs.find(({ id }) => id === rowValues.id)?.year_number;
  const yearDropdownOptions = getYearDropdownOptions({
    calendarYears,
    cnbcInputs,
    initiallySelectedYear,
  });
  const cnbcYearConfig = CREDITS_AND_BURSTS_CONFIG_ARRAY_CONFIG_MAP.get(
    CREDITS_AND_BURSTS_YEAR_NUMBER_BACKEND_NAME
  );
  return <FieldArrayGridSelectField columnConfig={cnbcYearConfig} options={yearDropdownOptions} />;
};
